var render, staticRenderFns
import script from "./AccordionElement.vue?vue&type=script&lang=js&"
export * from "./AccordionElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/eduardohdz/Documents/Trabajo/Repositorios/PlentyMarkets/Multicontent_latest/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05df7858')) {
      api.createRecord('05df7858', component.options)
    } else {
      api.reload('05df7858', component.options)
    }
    
  }
}
component.options.__file = "resources/js/src/components/AccordionElement.vue"
export default component.exports